var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var REDIRECT_METHOD = 'manual';
var REDIRECT_STATUS_300 = 300;
var BAD_REQUEST_STATUS_400 = 400;
var RESPONSE_TYPE_OPAQUE_REDIRECT = 'opaqueredirect';
var RESPONSE_HEADER_LOCATION = 'Location';
/**
 * Fetch wrapper for Sauron/Portal server requests that thorws an error when redirected. Intended to be used
 * for calls to Sauron/Portal server backed APIs.
 *
 * This method throws a specific error on redirect responses, which indicate AuthN/AuthZ issues
 * in Sauron/Portal server. Without this wrapper, these auth-related redirects would fail with generic
 * network errors due to CORS restrictions during automatic redirect following. This enables
 * proper error handling by the caller.
 *
 * @param {string} url - The URL to fetch from Sauron/Portal server
 * @param {RequestInit} options - Fetch API configuration options
 * @returns {Promise<Response>} The fetch response if successful
 * @throws {Error} When a redirect is detected, indicating potential auth issues
 *
 * @see https://issues.amazon.com/issues/V1604169984
 * @see https://t.corp.amazon.com/V1672394645/communication
 */
export function nonRedirectingMonsApiFetch(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var response, redirectedURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { redirect: REDIRECT_METHOD }))];
                case 1:
                    response = _a.sent();
                    // Standard check for redirected responses.
                    if (response.type === RESPONSE_TYPE_OPAQUE_REDIRECT
                        || (response.status >= REDIRECT_STATUS_300 && response.status < BAD_REQUEST_STATUS_400)) {
                        redirectedURL = response.headers.get(RESPONSE_HEADER_LOCATION);
                        throw new Error("Potential authentication issue, request redirected to: " + redirectedURL + " with status code: " + response.status);
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}
